import React from "react"
import CallToActionBanner from "@/components/CallToActionBanner"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { gtmTracking } from "@/utils/gtm-tracking"

const TryFreeCallToAction = ({
  title,
  showTitle = true,
  description,
  background,
  showFooter = true,
  primaryAction,
  secondaryAction,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <div className="container-fluid">
      <CallToActionBanner
        background={background}
        title={showTitle && (title ? title : t("common.try-free-14-days"))}
        description={description}
        footerText={showFooter && t("common.no-card-required")}
        action={props =>
          primaryAction ? (
            primaryAction
          ) : (
            <Link
              {...props}
              to="/signup/"
              onClick={() =>
                gtmTracking("CTA Click", t("common.try-free-14-days"), "")()
              }
            >
              {t("common.try-free-14-days")}
            </Link>
          )
        }
        secondaryAction={secondaryAction}
        children={children}
      />
    </div>
  )
}

export default TryFreeCallToAction
